var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row entity-content" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _vm.normalAction
              ? [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rulesField("name", { required: true }),
                          expression: "rulesField('name', { required: true })",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyForm,
                        disabled: _vm.readonlyForm,
                        id: "input-entity_name",
                        name: "entity_name",
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError(
                              "entity_name",
                              _vm.vScope
                            ),
                          },
                        ],
                        error: _vm.fnFirstError("entity_name", _vm.vScope),
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "name",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.name",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.name`)) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]
              : [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rulesField("entity_name", {
                            required: true,
                          }),
                          expression:
                            "rulesField('entity_name', { required: true })",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.readonlyForm,
                        id: `input-entity_name`,
                        name: `entity_name`,
                        noWrap: false,
                        initialData: _vm.form,
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError(
                              `entity_name`,
                              _vm.vScope
                            ),
                          },
                        ],
                        error: _vm.fnFirstError(`entity_name`, _vm.vScope),
                        label: _vm.entityLabel,
                        ajaxOptions: {
                          url: _vm.url.lookup,
                          urlParams: {
                            model: "entities",
                            id: _vm.form.entity_id,
                          },
                          shouldLoadDataOnDropdownOpen: true,
                        },
                        reduce: (onption) => onption[_vm.entityLabel],
                        allowCreate: true,
                        templateCreate: (label) =>
                          _vm.$t(`${_vm.modelTranslateID}.templateCreate`, {
                            label: label,
                          }),
                      },
                      on: {
                        selected: _vm.onSelectedEntity,
                        cleared: _vm.onClearedEntity,
                        created: _vm.onCreated,
                      },
                      model: {
                        value: _vm.form[_vm.entityLabel],
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            _vm.entityLabel,
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form[entityLabel]",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.name`)) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.showProperties
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-sm-6 col-md-5" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      { name: "lowercase", rawName: "v-lowercase" },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("phone", { email: true }),
                        expression: "rulesField('phone', { email: true })",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      autocomplete: "new-email",
                      readonly: _vm.entityReadonlyForm,
                      disabled: _vm.entityReadonlyForm,
                      type: "email",
                      id: "input-entity_email",
                      name: "entity_email",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_email",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_email", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "email",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.email",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.email`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-6 col-md-4" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("phone", {
                          numeric: true,
                          min_value: 1,
                          min: 9,
                          max: 14,
                        }),
                        expression:
                          "rulesField('phone', { numeric: true, min_value: 1, min: 9, max: 14 })",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      autocomplete: "new-phone",
                      readonly: _vm.entityReadonlyForm,
                      disabled: _vm.entityReadonlyForm,
                      id: "input-entity_phone",
                      name: "entity_phone",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_phone",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_phone", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "phone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.phone",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.phone`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-5 col-md-3" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("tax_number", {
                          nif: { countryCode: _vm.countryCodeNIF },
                        }),
                        expression:
                          "rulesField('tax_number', { nif: { countryCode: countryCodeNIF } })",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.entityReadonlyForm,
                      disabled: _vm.entityReadonlyForm,
                      id: "input-entity_tax_number",
                      name: "entity_tax_number",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_tax_number",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_tax_number", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.tax_number,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "tax_number",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.tax_number",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.tax_number`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-7 col-md-6" },
              [
                _c(
                  "MaterialSelect",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("cemetery_id", {
                          required: true,
                        }),
                        expression:
                          "rulesField('cemetery_id', { required: true })",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: _vm.entityReadonlyForm,
                      id: "input-entity_gender",
                      name: "entity_gender",
                      label: "name",
                      options: _vm.genders,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_gender",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_gender", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.gender_id,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "gender_id",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.gender_id",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.gender`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-12 col-md-6" },
              [
                _c(
                  "MaterialSelect",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("religion_type_id"),
                        expression: "rulesField('religion_type_id')",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: _vm.entityReadonlyForm,
                      id: "input-entity_religion",
                      name: "entity_religion",
                      label: "name",
                      options: _vm.religions,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_religion",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_religion", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.religion_type_id,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "religion_type_id",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.religion_type_id",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.religion`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-4 col-md-5" },
              [
                _c(
                  "MaterialDatePicker",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: _vm.readonlyForm,
                      id: "input-entity_birth_at",
                      name: "entity_birth_at",
                      dateFormat: _vm.labelDateFormat,
                      databaseDateFormat: _vm.dateFormat,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_birth_at",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_birth_at", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.birth_at,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "birth_at",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.birth_at",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.birth_at`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-4 col-md-5" },
              [
                _c(
                  "MaterialDatePicker",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("death_at", {
                          dateAfter: [
                            _vm.form.birth_at,
                            true,
                            _vm.$t(`${_vm.modelTranslateID}.birth_at`),
                          ],
                        }),
                        expression:
                          "rulesField('death_at', { dateAfter: [form.birth_at, true, $t(`${modelTranslateID}.birth_at`)] })",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: _vm.readonlyForm,
                      id: "input-entity_death_at",
                      name: "entity_death_at",
                      dateFormat: _vm.labelDateFormat,
                      databaseDateFormat: _vm.dateFormat,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_death_at",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_death_at", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.death_at,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "death_at",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.death_at",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.death_at`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-4 col-md-2" },
              [
                _c(
                  "MaterialInput",
                  {
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: true,
                      disabled: true,
                      id: "input-entity_age",
                      name: "entity_age",
                      value: _vm.age,
                      "data-vv-scope": _vm.vScope,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.age`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-12 col-md-4" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("father_affiliation"),
                        expression: "rulesField('father_affiliation')",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.entityReadonlyForm,
                      disabled: _vm.entityReadonlyForm,
                      id: "input-entity_father",
                      name: "entity_father",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_father",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_father", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.father_affiliation,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "father_affiliation",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.father_affiliation",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t(`${_vm.modelTranslateID}.father_affiliation`)
                        ) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-12 col-md-4" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("mother_affiliation"),
                        expression: "rulesField('mother_affiliation')",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.entityReadonlyForm,
                      disabled: _vm.entityReadonlyForm,
                      id: "input-entity_mother",
                      name: "entity_mother",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_mother",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_mother", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.mother_affiliation,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "mother_affiliation",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.mother_affiliation",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t(`${_vm.modelTranslateID}.mother_affiliation`)
                        ) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-12 col-md-4" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("entity_occupation"),
                        expression: "rulesField('entity_occupation')",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.entityReadonlyForm,
                      disabled: _vm.entityReadonlyForm,
                      id: "input-entity_occupation",
                      name: "entity_occupation",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_occupation",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_occupation", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.occupation,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "occupation",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.occupation",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.occupation`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-12 col-md" },
              [
                _c(
                  "MaterialSelect",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("cause_death_type_id"),
                        expression: "rulesField('cause_death_type_id')",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: _vm.entityReadonlyForm,
                      id: "input-entity_cause_death",
                      name: "entity_cause_death",
                      label: "name",
                      options: _vm.causes_death,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            "entity_cause_death",
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError("entity_cause_death", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.cause_death_type_id,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "cause_death_type_id",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.cause_death_type_id",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.cause_death`)) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-auto align-self-center form-group",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "form-check city-form-check form-check-inline",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.form.use_personal_data,
                          expression: "form.use_personal_data",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.entityReadonlyForm,
                        disabled: _vm.entityReadonlyForm,
                        type: "checkbox",
                        id: "input-use_personal_data",
                        name: "use_personal_data",
                        "false-value": false,
                        "true-value": true,
                      },
                      domProps: {
                        checked: Array.isArray(_vm.form.use_personal_data)
                          ? _vm._i(_vm.form.use_personal_data, null) > -1
                          : _vm.form.use_personal_data,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.form.use_personal_data,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "use_personal_data",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "use_personal_data",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "use_personal_data", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label h-auto",
                        attrs: { for: `input-use_personal_data` },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column align-items-start",
                          },
                          [
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      `${_vm.modelTranslateID}.use_personal_data`
                                    )
                                  )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 address" }, [
              _c("h6", { staticClass: "header" }, [
                _vm._v(
                  _vm._s(_vm.$t(`${_vm.translateID}.form.${_vm.addressTitle}`))
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-12" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: _vm.rulesField("entity_address", { min: 3 }),
                            expression:
                              "rulesField('entity_address', { min: 3 })",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.entityReadonlyForm,
                          disabled: _vm.entityReadonlyForm,
                          id: "input-entity_address",
                          name: "entity_address",
                          "data-vv-scope": _vm.vScope,
                          inputClasses: [
                            {
                              "is-invalid": _vm.fnHasError(
                                "entity_address",
                                _vm.vScope
                              ),
                            },
                          ],
                          error: _vm.fnFirstError("entity_address", _vm.vScope),
                        },
                        model: {
                          value: _vm.form.address,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "address",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.address",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.modelTranslateID}.address`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: _vm.rulesField("entity_locality"),
                            expression: "rulesField('entity_locality')",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.entityReadonlyForm,
                          disabled: _vm.entityReadonlyForm,
                          id: "input-entity_locality",
                          name: "entity_locality",
                          "data-vv-scope": _vm.vScope,
                          inputClasses: [
                            {
                              "is-invalid": _vm.fnHasError(
                                "entity_locality",
                                _vm.vScope
                              ),
                            },
                          ],
                          error: _vm.fnFirstError(
                            "entity_locality",
                            _vm.vScope
                          ),
                        },
                        model: {
                          value: _vm.form.locality,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "locality",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.locality",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t(`${_vm.modelTranslateID}.locality`)) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: _vm.rulesField("entity_postal_code", {
                              min: 8,
                              max: 8,
                              regex: /^\d{4}-\d{3}$/,
                            }),
                            expression:
                              "rulesField('entity_postal_code', { min: 8, max: 8, regex: /^\\d{4}-\\d{3}$/ })",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.entityReadonlyForm,
                          disabled: _vm.entityReadonlyForm,
                          id: "input-entity_postal_code",
                          name: "entity_postal_code",
                          "data-vv-scope": _vm.vScope,
                          inputClasses: [
                            {
                              "is-invalid": _vm.fnHasError(
                                "entity_postal_code",
                                _vm.vScope
                              ),
                            },
                          ],
                          error: _vm.fnFirstError(
                            "entity_postal_code",
                            _vm.vScope
                          ),
                        },
                        model: {
                          value: _vm.form.postal_code,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "postal_code",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.postal_code",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(`${_vm.modelTranslateID}.postal_code`)
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }